<template>
  <div class="swipe">
    <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
      <van-swipe-item @click="showImg(1)">
        <!-- <img src="@/assets/image/linshi/slide1.jpg" alt="" /> -->
        <img src="@/assets/image/linshi/slide4.jpg" alt="" />
      </van-swipe-item>
      <van-swipe-item @click="showImg(2)">
        <img src="@/assets/image/linshi/slide6.jpg" alt="" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview } from "vant";
export default {
  name: "swipe",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImagePreview.name]: ImagePreview
  },
  methods: {
    showImg(i) {
      if (i == 1) {
        ImagePreview({
          images: [require("@/assets/image/linshi/live.jpg")],
          showIndex: false
        });
      } else if (i == 2) {
        ImagePreview({
          images: [require("@/assets/image/linshi/read.jpg")],
          showIndex: false
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.swipe
  img
    display block
    width 100%
    height 140px
    object-fit cover
</style>
